/**
 * Phase 45 Plan 45-08 — task read-state API client (D-13, Open Q7).
 *
 * Backend contract (45-04):
 *   POST /api/tasks/:taskId/read → 204 (UPSERT lastReadAt for current user)
 *
 * Fired by useMarkTaskRead on TaskDetailSlideOver mount — closes the unread
 * comment-count loop end-to-end for MyTasks row signals.
 */
import { apiPost } from './client';

export async function markTaskRead(taskId: number): Promise<void> {
  await apiPost<void>(`/tasks/${taskId}/read`);
}
